import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TeamsVoicePoliciesFieldConfig } from '../../../shared/models/generated/ziroModels';
import { Observable } from 'rxjs';

@Injectable()
export class MicrosoftVoicePoliciesFieldConfigResource {
  private http = inject(HttpClient);

  get(
    tenantId: string | number,
    dialPlanId: number,
    isResourceAccount: boolean,
  ): Observable<TeamsVoicePoliciesFieldConfig> {
    return this.http.get<TeamsVoicePoliciesFieldConfig>(
      `/services/microsoft/field-configs/tenants/${tenantId}/teams-voice-policies/${dialPlanId}?isResourceAccount=${isResourceAccount}`,
    );
  }
}
